'use strict';

var tinycolor = require('@ctrl/tinycolor');

// src/tokens/themes/dark/colors.ts
var colorBaseNeutral50 = "#f5f5f5";
var colorBaseNeutral75 = "#e8e8e8";
var colorBaseNeutral100 = "#dbdbdb";
var colorBaseNeutral200 = "#bfbfbf";
var colorBaseNeutral300 = "#a3a3a3";
var colorBaseNeutral400 = "#8c8c8c";
var colorBaseNeutral500 = "#707070";
var colorBaseNeutral600 = "#575757";
var colorBaseNeutral700 = "#3d3d3d";
var colorBaseNeutral800 = "#292929";
var colorBaseNeutral900 = "#1a1a1a";
var colorBaseBlue50 = "#ebfaff";
var colorBaseBlue75 = "#ccf2ff";
var colorBaseBlue100 = "#b3ebff";
var colorBaseBlue200 = "#86d8f9";
var colorBaseBlue300 = "#3ab5ee";
var colorBaseBlue400 = "#1495e6";
var colorBaseBlue500 = "#136fd8";
var colorBaseBlue600 = "#0b54a8";
var colorBaseBlue700 = "#0a3d71";
var colorBaseBlue800 = "#0c2b45";
var colorBaseBlue900 = "#0b1b23";
var colorBaseOrange50 = "#fff4eb";
var colorBaseOrange75 = "#ffe3cc";
var colorBaseOrange100 = "#ffd3ad";
var colorBaseOrange200 = "#ffb570";
var colorBaseOrange300 = "#ff8404";
var colorBaseOrange400 = "#f76708";
var colorBaseOrange500 = "#ca3e07";
var colorBaseOrange600 = "#9e3105";
var colorBaseOrange700 = "#712304";
var colorBaseOrange800 = "#4f1803";
var colorBaseOrange900 = "#310f02";
var colorBaseYellow50 = "#fff9c0";
var colorBaseYellow75 = "#ffec8f";
var colorBaseYellow100 = "#ffd933";
var colorBaseYellow150 = "#ffc905";
var colorBaseYellow200 = "#ffbc05";
var colorBaseYellow250 = "#faab00";
var colorBaseYellow300 = "#f09800";
var colorBaseYellow350 = "#e58a00";
var colorBaseYellow400 = "#cc7a00";
var colorBaseYellow500 = "#a55f03";
var colorBaseYellow600 = "#824703";
var colorBaseRed50 = "#fdf2f2";
var colorBaseRed75 = "#ffe2df";
var colorBaseRed100 = "#ffd2cc";
var colorBaseRed200 = "#ffa799";
var colorBaseRed300 = "#ff7f6b";
var colorBaseRed400 = "#f55538";
var colorBaseRed500 = "#d42e1c";
var colorBaseRed600 = "#ac1e11";
var colorBaseRed700 = "#79150c";
var colorBaseRed800 = "#530e08";
var colorBaseRed900 = "#380a06";
var colorBaseGreen50 = "#d9fcde";
var colorBaseGreen75 = "#c6f4cc";
var colorBaseGreen100 = "#b1eaba";
var colorBaseGreen200 = "#78d389";
var colorBaseGreen300 = "#3cb95a";
var colorBaseGreen400 = "#00b14f";
var colorBaseGreen500 = "#00804a";
var colorBaseGreen600 = "#03633e";
var colorBaseGreen700 = "#005339";
var colorBaseGreen800 = "#002e27";
var colorBaseGreen900 = "#001e1f";

// src/tokens/gds-colors.ts
var gdsColorNeutral100 = "#dbdbdb";
var gdsColorNeutralWhite = "#ffffff";
var gdsColorGreen400 = "#00b14f";
var gdsColorGreen700 = "#005339";
var gdsColorBlue500 = "#136fd8";
var gdsColorOrange400 = "#f76708";
var gdsColorYellow300 = "#f09800";
var gdsColorRed500 = "#d42e1c";
var gdsColorIntegrityTeal50 = "#defbfc";
var gdsColorIntegrityTeal75 = "#a4f6f9";
var gdsColorIntegrityTeal100 = "#61eff5";
var gdsColorIntegrityTeal200 = "#0fd4db";
var gdsColorIntegrityTeal300 = "#01b5bc";
var gdsColorIntegrityTeal400 = "#009da3";
var gdsColorIntegrityTeal500 = "#008388";
var gdsColorIntegrityTeal600 = "#066165";
var gdsColorIntegrityTeal700 = "#0b4446";
var gdsColorIntegrityTeal800 = "#0f2d2f";
var gdsColorIntegrityTeal900 = "#0b1d1e";
var gdsColorDuxtonBlue50 = "#eef9f9";
var gdsColorDuxtonBlue75 = "#d2edea";
var gdsColorDuxtonBlue100 = "#b8e5df";
var gdsColorDuxtonBlue200 = "#84d2ca";
var gdsColorDuxtonBlue300 = "#4ab5aa";
var gdsColorDuxtonBlue400 = "#2d9f94";
var gdsColorDuxtonBlue500 = "#277c74";
var gdsColorDuxtonBlue600 = "#206059";
var gdsColorDuxtonBlue700 = "#184440";
var gdsColorDuxtonBlue800 = "#0f2e2b";
var gdsColorDuxtonBlue900 = "#091a19";

// src/tokens/themes/light/colors.ts
var colorBaseNeutral502 = "#f5f5f5";
var colorBaseNeutral752 = "#e8e8e8";
var colorBaseNeutral1002 = "#dbdbdb";
var colorBaseNeutral2002 = "#bfbfbf";
var colorBaseNeutral3002 = "#a3a3a3";
var colorBaseNeutral4002 = "#8c8c8c";
var colorBaseNeutral5002 = "#707070";
var colorBaseNeutral6002 = "#575757";
var colorBaseNeutral7002 = "#3d3d3d";
var colorBaseNeutral8002 = "#292929";
var colorBaseNeutral9002 = "#1a1a1a";
var colorBaseBlue502 = "#ebfaff";
var colorBaseBlue752 = "#ccf2ff";
var colorBaseBlue1002 = "#b3ebff";
var colorBaseBlue2002 = "#86d8f9";
var colorBaseBlue3002 = "#3ab5ee";
var colorBaseBlue4002 = "#1495e6";
var colorBaseBlue5002 = "#136fd8";
var colorBaseBlue6002 = "#0b54a8";
var colorBaseBlue7002 = "#0a3d71";
var colorBaseBlue8002 = "#0c2b45";
var colorBaseBlue9002 = "#0b1b23";
var colorBaseOrange502 = "#fff4eb";
var colorBaseOrange752 = "#ffe3cc";
var colorBaseOrange1002 = "#ffd3ad";
var colorBaseOrange2002 = "#ffb570";
var colorBaseOrange3002 = "#ff8404";
var colorBaseOrange4002 = "#f76708";
var colorBaseOrange5002 = "#ca3e07";
var colorBaseOrange6002 = "#9e3105";
var colorBaseOrange7002 = "#712304";
var colorBaseOrange8002 = "#4f1803";
var colorBaseOrange9002 = "#310f02";
var colorBaseYellow502 = "#fff9c0";
var colorBaseYellow752 = "#ffec8f";
var colorBaseYellow1002 = "#ffd933";
var colorBaseYellow1502 = "#ffc905";
var colorBaseYellow2002 = "#ffbc05";
var colorBaseYellow2502 = "#faab00";
var colorBaseYellow3002 = "#f09800";
var colorBaseYellow3502 = "#e58a00";
var colorBaseYellow4002 = "#cc7a00";
var colorBaseYellow5002 = "#a55f03";
var colorBaseYellow6002 = "#824703";
var colorBaseRed502 = "#fdf2f2";
var colorBaseRed752 = "#ffe2df";
var colorBaseRed1002 = "#ffd2cc";
var colorBaseRed2002 = "#ffa799";
var colorBaseRed3002 = "#ff7f6b";
var colorBaseRed4002 = "#f55538";
var colorBaseRed5002 = "#d42e1c";
var colorBaseRed6002 = "#ac1e11";
var colorBaseRed7002 = "#79150c";
var colorBaseRed8002 = "#530e08";
var colorBaseRed9002 = "#380a06";
var colorBaseGreen502 = "#d9fcde";
var colorBaseGreen752 = "#c6f4cc";
var colorBaseGreen1002 = "#b1eaba";
var colorBaseGreen2002 = "#78d389";
var colorBaseGreen3002 = "#3cb95a";
var colorBaseGreen4002 = "#00b14f";
var colorBaseGreen5002 = "#00804a";
var colorBaseGreen6002 = "#03633e";
var colorBaseGreen7002 = "#005339";
var colorBaseGreen8002 = "#002e27";
var colorBaseGreen9002 = "#001e1f";
var colorBrandPrimaryDefault = "#00b14f";
var colorStatusAlertDefault = "#d42e1c";
var colorStatusInformativeDefault = "#136fd8";
var colorStatusNoticeDefault = "#f09800";
var colorStatusNeutralDefault = "#707070";

// src/colors.ts
var colorPrimary = colorBrandPrimaryDefault;
var colorWarning = colorStatusNoticeDefault;
var colorError = colorStatusAlertDefault;
var colorInfo = colorStatusInformativeDefault;
var colorNeutral = colorStatusNeutralDefault;
var colorOrange = colorBaseOrange4002;
var colorTeal = gdsColorIntegrityTeal200;
var colorDuxtonBlue = gdsColorDuxtonBlue200;

// src/antd/dark/genColorMapToken.ts
var colors = {
  // Primary/Success
  // Grab Primary and Success is the same Green pallete
  [colorPrimary]: {
    1: colorBaseGreen50,
    2: colorBaseGreen75,
    3: colorBaseGreen100,
    4: colorBaseGreen200,
    5: colorBaseGreen300,
    6: colorBaseGreen400,
    7: colorBaseGreen500,
    8: colorBaseGreen600,
    9: colorBaseGreen700,
    10: colorBaseGreen800,
    11: colorBaseGreen900
  },
  // Error
  [colorError]: {
    1: colorBaseRed50,
    2: colorBaseRed75,
    3: colorBaseRed100,
    4: colorBaseRed200,
    5: colorBaseRed300,
    6: colorBaseRed400,
    7: colorBaseRed500,
    8: colorBaseRed600,
    9: colorBaseRed700,
    10: colorBaseRed800,
    11: colorBaseRed900
  },
  // Warrning
  [colorWarning]: {
    1: colorBaseYellow50,
    2: colorBaseYellow75,
    3: colorBaseYellow100,
    4: colorBaseYellow150,
    5: colorBaseYellow200,
    6: colorBaseYellow250,
    7: colorBaseYellow300,
    8: colorBaseYellow350,
    9: colorBaseYellow400,
    10: colorBaseYellow500,
    11: colorBaseYellow600
  },
  // Info/Link
  // Grab Info and Link using same Blue pallete
  [colorInfo]: {
    1: colorBaseBlue50,
    2: colorBaseBlue75,
    3: colorBaseBlue100,
    4: colorBaseBlue200,
    5: colorBaseBlue300,
    6: colorBaseBlue400,
    7: colorBaseBlue500,
    8: colorBaseBlue600,
    9: colorBaseBlue700,
    10: colorBaseBlue800,
    11: colorBaseBlue900
  },
  // Neutral
  [colorNeutral]: {
    1: colorBaseNeutral50,
    2: colorBaseNeutral75,
    3: colorBaseNeutral100,
    4: colorBaseNeutral200,
    5: colorBaseNeutral300,
    6: colorBaseNeutral400,
    7: colorBaseNeutral500,
    8: colorBaseNeutral600,
    9: colorBaseNeutral700,
    10: colorBaseNeutral800,
    11: colorBaseNeutral900
  },
  // Orange
  [colorOrange]: {
    1: colorBaseOrange50,
    2: colorBaseOrange75,
    3: colorBaseOrange100,
    4: colorBaseOrange200,
    5: colorBaseOrange300,
    6: colorBaseOrange400,
    7: colorBaseOrange500,
    8: colorBaseOrange600,
    9: colorBaseOrange700,
    10: colorBaseOrange800,
    11: colorBaseOrange900
  },
  // Cyan/teal
  [colorTeal]: {
    1: gdsColorIntegrityTeal50,
    2: gdsColorIntegrityTeal75,
    3: gdsColorIntegrityTeal100,
    4: gdsColorIntegrityTeal200,
    5: gdsColorIntegrityTeal300,
    6: gdsColorIntegrityTeal400,
    7: gdsColorIntegrityTeal500,
    8: gdsColorIntegrityTeal600,
    9: gdsColorIntegrityTeal700,
    10: gdsColorIntegrityTeal800,
    11: gdsColorIntegrityTeal900
  },
  // Duxton Blue/Geek Blue
  [colorDuxtonBlue]: {
    1: gdsColorDuxtonBlue50,
    2: gdsColorDuxtonBlue75,
    3: gdsColorDuxtonBlue100,
    4: gdsColorDuxtonBlue200,
    5: gdsColorDuxtonBlue300,
    6: gdsColorDuxtonBlue400,
    7: gdsColorDuxtonBlue500,
    8: gdsColorDuxtonBlue600,
    9: gdsColorDuxtonBlue700,
    10: gdsColorDuxtonBlue800,
    11: gdsColorDuxtonBlue900
  }
};
var generateColorPalettesDark = (baseColor) => {
  return colors[baseColor];
};

// src/antd/default/genColorMapToken.ts
var colors2 = {
  // Primary/Success
  // Grab Primary and Success is the same Green pallete
  [colorPrimary]: {
    1: colorBaseGreen502,
    2: colorBaseGreen752,
    3: colorBaseGreen1002,
    4: colorBaseGreen2002,
    5: colorBaseGreen3002,
    6: colorBaseGreen4002,
    7: colorBaseGreen5002,
    8: colorBaseGreen6002,
    9: colorBaseGreen7002,
    10: colorBaseGreen8002,
    11: colorBaseGreen9002
  },
  // Error
  [colorError]: {
    1: colorBaseRed502,
    2: colorBaseRed752,
    3: colorBaseRed1002,
    4: colorBaseRed2002,
    5: colorBaseRed3002,
    6: colorBaseRed4002,
    7: colorBaseRed5002,
    8: colorBaseRed6002,
    9: colorBaseRed7002,
    10: colorBaseRed8002,
    11: colorBaseRed9002
  },
  // Warrning
  [colorWarning]: {
    1: colorBaseYellow502,
    2: colorBaseYellow752,
    3: colorBaseYellow1002,
    4: colorBaseYellow1502,
    5: colorBaseYellow2002,
    6: colorBaseYellow2502,
    7: colorBaseYellow3002,
    8: colorBaseYellow3502,
    9: colorBaseYellow4002,
    10: colorBaseYellow5002,
    11: colorBaseYellow6002
  },
  // Info/Link
  // Grab Info and Link using same Blue pallete
  [colorInfo]: {
    1: colorBaseBlue502,
    2: colorBaseBlue752,
    3: colorBaseBlue1002,
    4: colorBaseBlue2002,
    5: colorBaseBlue3002,
    6: colorBaseBlue4002,
    7: colorBaseBlue5002,
    8: colorBaseBlue6002,
    9: colorBaseBlue7002,
    10: colorBaseBlue8002,
    11: colorBaseBlue9002
  },
  // Neutral
  [colorNeutral]: {
    1: colorBaseNeutral502,
    2: colorBaseNeutral752,
    3: colorBaseNeutral1002,
    4: colorBaseNeutral2002,
    5: colorBaseNeutral3002,
    6: colorBaseNeutral4002,
    7: colorBaseNeutral5002,
    8: colorBaseNeutral6002,
    9: colorBaseNeutral7002,
    10: colorBaseNeutral8002,
    11: colorBaseNeutral9002
  },
  // Orange
  [colorOrange]: {
    1: colorBaseOrange502,
    2: colorBaseOrange752,
    3: colorBaseOrange1002,
    4: colorBaseOrange2002,
    5: colorBaseOrange3002,
    6: colorBaseOrange4002,
    7: colorBaseOrange5002,
    8: colorBaseOrange6002,
    9: colorBaseOrange7002,
    10: colorBaseOrange8002,
    11: colorBaseOrange9002
  },
  // Cyan/teal
  [colorTeal]: {
    1: gdsColorIntegrityTeal50,
    2: gdsColorIntegrityTeal75,
    3: gdsColorIntegrityTeal100,
    4: gdsColorIntegrityTeal200,
    5: gdsColorIntegrityTeal300,
    6: gdsColorIntegrityTeal400,
    7: gdsColorIntegrityTeal500,
    8: gdsColorIntegrityTeal600,
    9: gdsColorIntegrityTeal700,
    10: gdsColorIntegrityTeal800,
    11: gdsColorIntegrityTeal900
  },
  // Duxton Blue/Geek Blue
  [colorDuxtonBlue]: {
    1: gdsColorDuxtonBlue50,
    2: gdsColorDuxtonBlue75,
    3: gdsColorDuxtonBlue100,
    4: gdsColorDuxtonBlue200,
    5: gdsColorDuxtonBlue300,
    6: gdsColorDuxtonBlue400,
    7: gdsColorDuxtonBlue500,
    8: gdsColorDuxtonBlue600,
    9: gdsColorDuxtonBlue700,
    10: gdsColorDuxtonBlue800,
    11: gdsColorDuxtonBlue900
  }
};
var generateColorPalettesDefault = (baseColor) => {
  return colors2[baseColor];
};
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [
  { index: 7, opacity: 0.15 },
  { index: 6, opacity: 0.25 },
  { index: 5, opacity: 0.3 },
  { index: 5, opacity: 0.45 },
  { index: 5, opacity: 0.65 },
  { index: 5, opacity: 0.85 },
  { index: 4, opacity: 0.9 },
  { index: 3, opacity: 0.95 },
  { index: 2, opacity: 0.97 },
  { index: 1, opacity: 0.98 }
];
function toHsv({ r, g, b }) {
  const hsv = tinycolor.rgbToHsv(r, g, b);
  return { h: hsv.h * 360, s: hsv.s, v: hsv.v };
}
function toHex({ r, g, b }) {
  return `#${tinycolor.rgbToHex(r, g, b, false)}`;
}
function mix(rgb1, rgb2, amount) {
  const p = amount / 100;
  const rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}
function getHue(hsv, i, light) {
  let hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240)
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  else
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  if (hue < 0)
    hue += 360;
  else if (hue >= 360)
    hue -= 360;
  return hue;
}
function getSaturation(hsv, i, light) {
  if (hsv.h === 0 && hsv.s === 0)
    return hsv.s;
  let saturation;
  if (light)
    saturation = hsv.s - saturationStep * i;
  else if (i === darkColorCount)
    saturation = hsv.s + saturationStep;
  else
    saturation = hsv.s + saturationStep2 * i;
  if (saturation > 1)
    saturation = 1;
  if (light && i === lightColorCount && saturation > 0.1)
    saturation = 0.1;
  if (saturation < 0.06)
    saturation = 0.06;
  return Number(saturation.toFixed(2));
}
function getValue(hsv, i, light) {
  let value;
  if (light)
    value = hsv.v + brightnessStep1 * i;
  else
    value = hsv.v - brightnessStep2 * i;
  if (value > 1)
    value = 1;
  return Number(value.toFixed(2));
}
function generate(color, opts = {}) {
  const patterns = [];
  const pColor = tinycolor.inputToRGB(color);
  for (let i = lightColorCount; i > 0; i -= 1) {
    const hsv = toHsv(pColor);
    const colorString = toHex(
      tinycolor.inputToRGB({
        h: getHue(hsv, i, true),
        s: getSaturation(hsv, i, true),
        v: getValue(hsv, i, true)
      })
    );
    patterns.push(colorString);
  }
  patterns.push(toHex(pColor));
  for (let i = 1; i <= darkColorCount; i += 1) {
    const hsv = toHsv(pColor);
    const colorString = toHex(
      tinycolor.inputToRGB({
        h: getHue(hsv, i),
        s: getSaturation(hsv, i),
        v: getValue(hsv, i)
      })
    );
    patterns.push(colorString);
  }
  if (opts.theme === "dark") {
    const DuxtonColorPalettes2 = generateColorPalettesDark(color);
    if (DuxtonColorPalettes2)
      return Object.values(DuxtonColorPalettes2);
    return darkColorMap.map(({ index, opacity }) => {
      const darkColorString = toHex(
        mix(
          tinycolor.inputToRGB(opts.backgroundColor || "#141414"),
          tinycolor.inputToRGB(patterns[index]),
          opacity * 100
        )
      );
      return darkColorString;
    });
  }
  const DuxtonColorPalettes = generateColorPalettesDefault(color);
  if (DuxtonColorPalettes)
    return Object.values(DuxtonColorPalettes);
  return patterns;
}

// src/antd/colors.ts
var presetPrimaryColors = {
  red: gdsColorRed500,
  volcano: "#FA541C",
  // Dui: deprecating
  orange: gdsColorOrange400,
  gold: "#FAAD14",
  // Dui: deprecating
  yellow: gdsColorYellow300,
  lime: "#A0D911",
  // Dui: deprecating
  green: gdsColorGreen400,
  cyan: gdsColorIntegrityTeal200,
  // Dui: deprecating
  blue: gdsColorBlue500,
  // Dui: deprecating
  geekblue: gdsColorDuxtonBlue200,
  // Dui: deprecating
  purple: "#722ED1",
  magenta: "#EB2F96",
  // Dui: deprecating
  grey: gdsColorNeutral100,
  white: gdsColorNeutralWhite,
  // Dui
  darkgreen: gdsColorGreen700
  // Dui
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach((key) => {
  presetPalettes[key] = generate(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5];
  presetDarkPalettes[key] = generate(presetPrimaryColors[key], {
    theme: "dark",
    backgroundColor: "#141414"
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
var red = presetPalettes.red;
var volcano = presetPalettes.volcano;
var gold = presetPalettes.gold;
var orange = presetPalettes.orange;
var yellow = presetPalettes.yellow;
var lime = presetPalettes.lime;
var green = presetPalettes.green;
var cyan = presetPalettes.cyan;
var blue = presetPalettes.blue;
var geekblue = presetPalettes.geekblue;
var purple = presetPalettes.purple;
var magenta = presetPalettes.magenta;
var grey = presetPalettes.grey;
var gray = presetPalettes.grey;
var darkgreen = presetPalettes.darkgreen;
var teal = presetPalettes.cyan;

exports.blue = blue;
exports.cyan = cyan;
exports.darkgreen = darkgreen;
exports.geekblue = geekblue;
exports.generate = generate;
exports.generateColorPalettesDark = generateColorPalettesDark;
exports.generateColorPalettesDefault = generateColorPalettesDefault;
exports.gold = gold;
exports.gray = gray;
exports.green = green;
exports.grey = grey;
exports.lime = lime;
exports.magenta = magenta;
exports.orange = orange;
exports.presetDarkPalettes = presetDarkPalettes;
exports.presetPalettes = presetPalettes;
exports.presetPrimaryColors = presetPrimaryColors;
exports.purple = purple;
exports.red = red;
exports.teal = teal;
exports.volcano = volcano;
exports.yellow = yellow;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=antd.js.map